
const menus: any = {
  menus: [],
}
export default menus
